import { memo, useContext } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { getHideDiscountHBX } from "app/reducers/brandSelector";
import Total from "app/pages/.shared/PriceSummary/Total/Total";
import TotalNote from "app/pages/.shared/PriceSummary/TotalNote/TotalNote";
import AmountContainer from "app/pages/.shared/AmountContainer";
import SavingsHighlight from "app/pages/.shared/SavingsHighlight/SavingsHighlight";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import appGlobalsContext from "app/AppGlobalsContext";
import { QuotationPriceDetailContainer } from "app/pages/Booking/Quotation/PriceDetails/QuotationPriceDetailContainer.jsx";
import "./PriceSummary.scss";

const QuotationPriceSummary = ({
	hasChildren,
	total,
	boardDiscount = 0,
	hideDiscountHBX = false,
}) => {
	const { resolution } = useContext(appGlobalsContext);
	const isMobile = resolution === RESOLUTION.MEDIUM || resolution === RESOLUTION.SMALL;
	const totalPrice = Number(total) || 0;
	const publicPrice = boardDiscount > 0 ? totalPrice + boardDiscount : 0;

	return (
		<>
			<div className="price-summary">
				{isMobile && (
					<>
						<QuotationPriceDetailContainer />
					</>
				)}

				{!isMobile && (
					<>
						<div className="price-summary__item">
							<Total total={total} taxesAndFeesIncluded />
						</div>
						{boardDiscount > 0 && !hideDiscountHBX && (
							<div className="price-summary__item price-summary__item--savings">
								<SavingsHighlight
									message={
										<FormattedMessage
											id="general.savings.realized.with.amount"
											values={{
												price: <AmountContainer amount={boardDiscount} />,
											}}
										/>
									}
									trackEvent="booking_click_savings_realized"
									trackData={{ discountValue: boardDiscount, publicPrice }}
									description={
										<div className="savings-highlight__description-block">
											<div className="savings-highlight__description-title">
												<FormattedMessage id="savings.tooltip.title" />
											</div>
											<ul className="savings-highlight__list">
												<li>
													<FormattedMessage id="savings.tooltip.line1" />
												</li>
												<li>
													<FormattedMessage id="savings.tooltip.line2" />
												</li>
											</ul>
										</div>
									}
									descriptionAmountLabel={
										<FormattedMessage id="savings.tooltip.amount.label" />
									}
									showDescriptionAmount
									amount={boardDiscount}
								/>
								<div className="price-summary__reference">
									<FormattedMessage
										id="general.instead.of.price.with.amount"
										values={{
											price: <AmountContainer amount={publicPrice} />,
										}}
									/>
								</div>
							</div>
						)}

						<TotalNote showChildrenNote={hasChildren} />
					</>
				)}
			</div>
		</>
	);
};

QuotationPriceSummary.propTypes = {
	total: PropTypes.number,
	hasChildren: PropTypes.bool,
	boardDiscount: PropTypes.number,
	hideDiscountHBX: PropTypes.bool,
};

const mapStateToProps = state => ({
	boardDiscount: Number(state?.booking?.board?.discount) || 0,
	hideDiscountHBX: getHideDiscountHBX(state),
});

export default connect(mapStateToProps)(memo(QuotationPriceSummary));
